import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { WA_NAVIGATOR, WA_WINDOW } from '@ng-web-apis/common';
import { TranslateModule } from '@ngx-translate/core';
import { TuiLink } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';

import { ModalContext } from '../modal';

type NotificationWithLinkOptions = { messageKey: string; link: string; interpolateParams?: Record<string, unknown> };

@Component({
  selector: 'ion-notification-with-link',
  imports: [TranslateModule, RouterLink, TuiLink],
  templateUrl: './notification-with-link.component.html',
  styleUrls: ['./notification-with-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationWithLinkComponent {
  readonly context = inject(POLYMORPHEUS_CONTEXT) as ModalContext<NotificationWithLinkOptions, void>;
  private readonly navigator = inject(WA_NAVIGATOR);
  private readonly window = inject(WA_WINDOW);

  copyLink() {
    this.navigator.clipboard.writeText(this.window.location.origin + this.context.data.link);
  }
}
